<template>
  <div id="map-viewer-menu" :style="{ height: tinggiSheet, left: `${insetLeft}px` }">
    <div id="menu-bar">
      <div id="sheet-controls">
        <button type="button" class="sheet-btn" @click="$emit('set-sheet', level === 'full' ? 'half' : 'full')">
          {{ level === 'full' ? 'Collapse' : 'Expand' }}
        </button>
        <button type="button" class="sheet-btn" @click="$emit('set-sheet', 'closed')">Close</button>
      </div>

      <div v-if="menuActive === 0" id="datalog-header" class="d-flex align-items-center">
        <div class="ml-3">
          <select name="" class="form-control" v-model="unit.speed">
            <option value="knot">KNOT</option>
            <option value="km/h">KM/H</option>
          </select>
        </div>
        <div class="ml-3">
          <select name="" class="form-control" v-model="unit.distance">
            <option value="nm">NM</option>
            <option value="km">KM</option>
          </select>
        </div>
        <div class="ml-3">
          <select name="" class="form-control" v-model="dataSort">
            <option value="latest">Latest</option>
            <option value="oldest">Oldest</option>
          </select>
        </div>
        <div class="ml-3">
          <button class="btn btn-outline-primary" @click="showShowHideModal">
            Filter Column
          </button>
        </div>
        <div class="ml-3">
          <button class="btn btn-success" @click="onDownloadExcel">
            Download XLSX
          </button>
        </div>

        <!-- show/hide column modal -->
        <b-modal id="show-hide-column-modal" title="Show/Hide Datalog Column" size="xl">
          <div class="row">
            <div v-for="(columns, key) in availableColumns" :key="key" class="col-4">
              <h5>{{ labelGrup(key) }}</h5>
              <div>
                <input type="checkbox" :id="`${key}-all`" :checked="areAllVisible(key)"
                  @change="toggleAllColumns(key)" />
                <label :for="`${key}-all`" class="ml-1">
                  {{ areAllVisible(key) ? 'Hide All' : 'Show All' }}
                </label>
              </div>
              <div v-for="column in columns" :key="column">
                <input type="checkbox" :id="column" :value="column" v-model="visibleColumns[key]" />
                <label :for="column" class="ml-1">{{ column.charAt(0).toUpperCase() + column.slice(1) }}</label>
              </div>
            </div>
          </div>
        </b-modal>
        <!-- ./ show/hide column modal -->
      </div>

      <div v-if="menuActive === 1" id="chart-header">
        <div
          v-for="tab in chartTabs"
          :key="tab.index"
          class="chart-selector"
          :class="{ 'active-chart-selector': chartActive === tab.index }"
          @click="chartActive = tab.index">
          {{ tab.label }}
        </div>
      </div>
    </div>
    <div id="menu-content">
      <div id="content-selector">
        <div class="selector" :class="{ 'active-selector': menuActive === 0 }" @click="menuActive = 0">
          <img :src="menuActive === 0 ? icon.TableIconLight : icon.TableIcon" width="75%" />
        </div>
        <div class="selector" :class="{ 'active-selector': menuActive === 1 }" @click="menuActive = 1">
          <img :src="menuActive === 1 ? icon.ChartLineIconLight : icon.ChartLineIcon" width="75%" />
        </div>
      </div>

      <div v-if="menuActive === 0" id="datalog-content">
        <table v-if="currAssetSummary && visibleColumns.gps">
          <thead>
            <tr>
              <th class="sticky-column" rowspan="2">No</th>
              <th class="sticky-column" rowspan="2">Date Time</th>
              <th v-if="visibleColumns.gps.includes('coordinate')" rowspan="2">First Coordinate
              </th>
              <th v-if="visibleColumns.gps.includes('coordinate')" rowspan="2">Last Coordinate
              </th>
              <th v-if="visibleColumns.gps.includes('heading')" rowspan="2">Heading</th>
              <th v-if="visibleColumns.gps.includes('speed')" rowspan="2">Speed ({{ unit.speed.toUpperCase() }})</th>
              <th v-if="visibleColumns.gps.includes('cruise')" rowspan="2">Cruise ({{ unit.distance.toUpperCase() }})
              </th>
              <th
                v-for="tipe in kolomMesin"
                v-show="visibleCount(tipe.toLowerCase()) > 0"
                :key="`h-${tipe}`"
                :colspan="visibleCount(tipe.toLowerCase())">{{ tipe }}</th>

              <th
                v-for="i in currCapability.aeCount"
                v-show="visibleCount(`ae${i}`) > 0"
                :key="`h-ae${i}`"
                :colspan="visibleCount(`ae${i}`)">AE {{ i }}</th>

              <th
                v-for="nama in grupFuelYatim"
                v-show="visibleCount(`fuel:${nama}`) > 0"
                :key="`h-fuel-${nama}`"
                :colspan="visibleCount(`fuel:${nama}`)">{{ nama }}</th>
            </tr>
            <tr>
              <template v-for="tipe in kolomMesin">
                <th v-if="visibleColumns[tipe.toLowerCase()].includes('rpm')" :key="`s-${tipe}-rpm`">RPM</th>
                <th v-if="visibleColumns[tipe.toLowerCase()].includes('runningHours')" :key="`s-${tipe}-rh`">Run. Hours</th>
                <th v-if="visibleColumns[tipe.toLowerCase()].includes('volumeInventory')" :key="`s-${tipe}-vi1`">First Volume Total In (Liter)</th>
                <th v-if="visibleColumns[tipe.toLowerCase()].includes('volumeInventory')" :key="`s-${tipe}-vi2`">Last Volume Total In (Liter)</th>
                <th v-if="visibleColumns[tipe.toLowerCase()].includes('volumeFlowrate')" :key="`s-${tipe}-vf`">In FLow (L/H)</th>
                <th v-if="visibleColumns[tipe.toLowerCase()].includes('temperature')" :key="`s-${tipe}-t`">In Temp. (&deg;C)</th>
                <th v-if="visibleColumns[tipe.toLowerCase()].includes('density')" :key="`s-${tipe}-d`">IN Density (g/cm&sup3;)</th>
              </template>

              <template v-for="i in currCapability.aeCount">
                <th v-if="visibleColumns[`ae${i}`].includes('runningHours')" :key="`s-ae${i}-rh`">Run. Hours</th>
                <th v-if="visibleColumns[`ae${i}`].includes('fuelConsumption')" :key="`s-ae${i}-fc`">Fuel Cons (Liter)</th>
              </template>

              <template v-for="nama in grupFuelYatim">
                <th v-if="visibleColumns[`fuel:${nama}`].includes('volumeInventory')" :key="`s-f${nama}-vi1`">First Volume Total In (Liter)</th>
                <th v-if="visibleColumns[`fuel:${nama}`].includes('volumeInventory')" :key="`s-f${nama}-vi2`">Last Volume Total In (Liter)</th>
                <th v-if="visibleColumns[`fuel:${nama}`].includes('volumeFlowrate')" :key="`s-f${nama}-vf`">In FLow (L/H)</th>
                <th v-if="visibleColumns[`fuel:${nama}`].includes('temperature')" :key="`s-f${nama}-t`">In Temp. (&deg;C)</th>
                <th v-if="visibleColumns[`fuel:${nama}`].includes('density')" :key="`s-f${nama}-d`">IN Density (g/cm&sup3;)</th>
              </template>
            </tr>
          </thead>

          <tbody class="monospaced">
            <tr
              v-for="data in currAssetSummary.series"
              :key="data.timestamp"
              @mouseenter="sorotBaris(data)"
              @mouseleave="lepasBaris">
              <td class="sticky-column"> {{ currAssetSummary.series.indexOf(data) + 1 }} </td>
              <td class="sticky-column"> {{ formatDisplay(data.timestamp * 1000) }}</td>
              <td v-if="visibleColumns.gps.includes('coordinate')" class="not-monospaced">{{
                typeof data?.gpsData?.latitude !== 'undefined' && typeof data?.gpsData?.longitude !== 'undefined'
                  ? `${convertDecimalToDMS(data?.gpsData?.latitude, true)},
                ${convertDecimalToDMS(data?.gpsData?.longitude, false)}`
                  : '-'
              }}</td>
              <td v-if="visibleColumns.gps.includes('coordinate')" class="not-monospaced">{{
                typeof data?.gpsData?.additional?.LAST_dlgpLatitude_4 !== 'undefined' && typeof
                  data?.gpsData?.additional?.LAST_dlgpLongitude_5 !== 'undefined'
                  ? `${convertDecimalToDMS(data?.gpsData?.additional?.LAST_dlgpLatitude_4, true)},
                ${convertDecimalToDMS(data?.gpsData?.additional?.LAST_dlgpLongitude_5, false)}`
                  : '-'
              }}</td>
              <td v-if="visibleColumns.gps.includes('heading')">{{ typeof data?.gpsData?.track !== 'undefined' ?
                $fmt(data?.gpsData?.track, 2) : '-' }}&deg;</td>
              <td v-if="visibleColumns.gps.includes('speed')">{{
                typeof data?.gpsData?.speed !== 'undefined'
                  ? unit.speed === 'knot'
                    ? $fmt((data?.gpsData?.speed * 0.539957), 2) : $fmt(data?.gpsData?.speed, 2)
                  : '-'
              }}</td>
              <td v-if="visibleColumns.gps.includes('cruise')">{{
                typeof data?.gpsData?.additional?.SUM_dlgpDistance_3 !== 'undefined'
                  ? unit.distance === 'nm'
                    ? $fmt((data?.gpsData?.additional?.SUM_dlgpDistance_3 * 0.000539957), 2)
                    : $fmt((data?.gpsData?.additional?.SUM_dlgpDistance_3 * 0.001), 2)
                  : '-'
              }}</td>

              <template v-for="tipe in kolomMesin">
                <td v-if="visibleColumns[tipe.toLowerCase()].includes('rpm')" :key="`${tipe}-rpm`">{{
                  typeof data?.rpmData?.[tipe]?.rpm !== 'undefined'
                    ? $fmt(data?.rpmData?.[tipe]?.rpm, 2) : '-' }}</td>
                <td v-if="visibleColumns[tipe.toLowerCase()].includes('runningHours')" :key="`${tipe}-rh`">{{
                  typeof data?.rpmData?.[tipe]?.additional?.COUNTGT_dlrpRpm_1 !== 'undefined'
                    ? toDuration(data?.rpmData?.[tipe]?.additional?.COUNTGT_dlrpRpm_1 * 60) : '-' }}</td>
                <td v-if="visibleColumns[tipe.toLowerCase()].includes('volumeInventory')" :key="`${tipe}-vi1`">{{
                  typeof data?.fmData?.[tipe + '_IN']?.additional?.FIRST_dlfmVolInventory_0 !== 'undefined'
                    ? $fmt(data?.fmData?.[tipe + '_IN']?.additional?.FIRST_dlfmVolInventory_0, 2) : '-' }}</td>
                <td v-if="visibleColumns[tipe.toLowerCase()].includes('volumeInventory')" :key="`${tipe}-vi2`">{{
                  typeof data?.fmData?.[tipe + '_IN']?.additional?.LAST_dlfmVolInventory_1 !== 'undefined'
                    ? $fmt(data?.fmData?.[tipe + '_IN']?.additional?.LAST_dlfmVolInventory_1, 2) : '-' }}</td>
                <td v-if="visibleColumns[tipe.toLowerCase()].includes('volumeFlowrate')" :key="`${tipe}-vf`">{{
                  typeof data?.fmData?.[tipe + '_IN']?.volumeFlowrate !== 'undefined'
                    ? $fmt(data?.fmData?.[tipe + '_IN']?.volumeFlowrate, 2) : '-' }}</td>
                <td v-if="visibleColumns[tipe.toLowerCase()].includes('temperature')" :key="`${tipe}-t`">{{
                  typeof data?.fmData?.[tipe + '_IN']?.temperature !== 'undefined'
                    ? $fmt(data?.fmData?.[tipe + '_IN']?.temperature, 2) : '-' }}</td>
                <td v-if="visibleColumns[tipe.toLowerCase()].includes('density')" :key="`${tipe}-d`">{{
                  typeof data?.fmData?.[tipe + '_IN']?.density !== 'undefined'
                    ? $fmt(data?.fmData?.[tipe + '_IN']?.density, 2) : '-' }}</td>
              </template>

              <template v-for="i in currCapability.aeCount">
                <td v-if="visibleColumns[`ae${i}`].includes('runningHours')" :key="`ae${i}-rh`">{{
                  typeof data?.aeData?.['AE' + i]?.runningSeconds !== 'undefined'
                    ? toDuration(data?.aeData?.['AE' + i]?.runningSeconds) : '-' }}</td>
                <td v-if="visibleColumns[`ae${i}`].includes('fuelConsumption')" :key="`ae${i}-fc`">{{
                  typeof data?.aeData?.['AE' + i]?.fuelConsumption !== 'undefined'
                    ? $fmt(data?.aeData?.['AE' + i]?.fuelConsumption, 2) : '-' }}</td>
              </template>

              <template v-for="nama in grupFuelYatim">
                <td v-if="visibleColumns[`fuel:${nama}`].includes('volumeInventory')" :key="`f${nama}-vi1`">{{
                  typeof data?.fmData?.[nama + '_IN']?.additional?.FIRST_dlfmVolInventory_0 !== 'undefined'
                    ? $fmt(data?.fmData?.[nama + '_IN']?.additional?.FIRST_dlfmVolInventory_0, 2) : '-' }}</td>
                <td v-if="visibleColumns[`fuel:${nama}`].includes('volumeInventory')" :key="`f${nama}-vi2`">{{
                  typeof data?.fmData?.[nama + '_IN']?.additional?.LAST_dlfmVolInventory_1 !== 'undefined'
                    ? $fmt(data?.fmData?.[nama + '_IN']?.additional?.LAST_dlfmVolInventory_1, 2) : '-' }}</td>
                <td v-if="visibleColumns[`fuel:${nama}`].includes('volumeFlowrate')" :key="`f${nama}-vf`">{{
                  typeof data?.fmData?.[nama + '_IN']?.volumeFlowrate !== 'undefined'
                    ? $fmt(data?.fmData?.[nama + '_IN']?.volumeFlowrate, 2) : '-' }}</td>
                <td v-if="visibleColumns[`fuel:${nama}`].includes('temperature')" :key="`f${nama}-t`">{{
                  typeof data?.fmData?.[nama + '_IN']?.temperature !== 'undefined'
                    ? $fmt(data?.fmData?.[nama + '_IN']?.temperature, 2) : '-' }}</td>
                <td v-if="visibleColumns[`fuel:${nama}`].includes('density')" :key="`f${nama}-d`">{{
                  typeof data?.fmData?.[nama + '_IN']?.density !== 'undefined'
                    ? $fmt(data?.fmData?.[nama + '_IN']?.density, 2) : '-' }}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="menuActive === 1" id="chart-content">
        <RpmFuelSpeed v-if="chartActive === 0" :series="currAssetSummary.series" :deviceStatus="currCapability" />
        <FuelCharacteristics v-if="chartActive === 1" :series="currAssetSummary.series" type="PORT" :deviceStatus="currCapability" />
        <FuelCharacteristics v-if="chartActive === 2" :series="currAssetSummary.series" type="STARBOARD" :deviceStatus="currCapability" />
        <AuxiliaryEngineUsage v-if="chartActive === 3" :series="currAssetSummary.series" :deviceStatus="currCapability" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { toDuration, formatDateTime } from '@/util/date';
import { DISPLAY_DATETIME } from '@/util/apiDatetime';
import { buildFmsSeries } from '@/util/fms-summary';
import { capabilityFromSummary } from '@/util/seriesToSummaryData';
import { publish, HOVER } from '@/util/chartSync';
import { numericCell } from '@/util/number';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import AuxiliaryEngineUsage from '@/components/charts/AuxiliaryEngineUsage';
import RpmFuelSpeed from '@/components/charts/RpmFuelSpeed';
import FuelCharacteristics from '@/components/charts/FuelCharacteristics';

import CloseMenuIcon from '@/assets/icons/close-menu-icon.svg';
import ChartLineIcon from '@/assets/icons/chart-line-icon.svg';
import ChartLineIconLight from '@/assets/icons/chart-line-icon-light.svg';
import TableIcon from '@/assets/icons/table-icon.svg';
import TableIconLight from '@/assets/icons/table-icon-light.svg';

export default {
  name: 'MapViewerMenu',
  props: {
    level: {
      type: String,
      default: 'half',
    },
    // Sheet mulai setelah panel kiri biar kolom pertama tabel gak ketutup.
    insetLeft: {
      type: Number,
      default: 0,
    },
  },
  components: {
    AuxiliaryEngineUsage,
    RpmFuelSpeed,
    FuelCharacteristics,
  },
  data() {
    return {
      icon: {
        CloseMenuIcon,
        ChartLineIcon,
        ChartLineIconLight,
        TableIcon,
        TableIconLight,
      },
      menuActive: 0,
      chartActive: 0,
      unit: {
        speed: 'knot',
        distance: 'nm',
      },
      dataSort: 'oldest',
      visibleColumns: {},
      lebarLayar: window.innerWidth,
    };
  },
  mounted() {
    this._onResize = () => {
      this.lebarLayar = window.innerWidth;
    };
    window.addEventListener('resize', this._onResize);
  },
  computed: {
    tinggiSheet() {
      const kecil = this.lebarLayar < 768;
      if (this.level === 'full') return kecil ? '85vh' : '70vh';
      return kecil ? '45vh' : '375px';
    },
    dateRange: {
      get() {
        const { start, end } = this.$store.getters['filter/date'];
        const startDate = new Date(moment(start).valueOf());
        const endDate = new Date(moment(end).valueOf());

        return { start: startDate, end: endDate };
      },
      set(val) {
        const start = moment(val.start);
        const end = moment(val.end);

        this.$store.commit('filter/SET_DATE', { start, end });
      },
    },
    currCapability() {
      return capabilityFromSummary(this.currAsset?.deviceStatus, this.currAsset?.summary);
    },
    fmGroupNames() {
      return (this.currCapability.flowmeterGroups || []).map((g) => g.name);
    },
    kolomMesin() {
      return this.currCapability.rpmTypes;
    },
    chartTabs() {
      const tabs = [{ index: 0, label: 'RPM, Fuel Cons, Speed' }];
      if (this.fmGroupNames.includes('PORT')) tabs.push({ index: 1, label: 'Port Fuel Characteristic' });
      if (this.fmGroupNames.includes('STARBOARD')) tabs.push({ index: 2, label: 'STBD Fuel Characteristic' });
      if (this.currCapability.aeCount > 0) tabs.push({ index: 3, label: 'Auxiliary Engine Usage' });
      return tabs;
    },
    // Group flowmeter yang gak punya posisi RPM senama, mis. AE_INLINE di kapal tanpa RPM.
    grupFuelYatim() {
      return this.fmGroupNames.filter((n) => !this.currCapability.rpmTypes.includes(n));
    },
    availableColumns() {
      const kolom = { gps: ['coordinate', 'heading', 'speed', 'cruise'] };
      const dasar = ['rpm', 'runningHours'];
      const fuel = ['volumeInventory', 'volumeFlowrate', 'temperature', 'density'];
      this.currCapability.rpmTypes.forEach((tipe) => {
        kolom[tipe.toLowerCase()] = this.fmGroupNames.includes(tipe) ? [...dasar, ...fuel] : dasar;
      });
      for (let i = 1; i <= this.currCapability.aeCount; i += 1) {
        kolom[`ae${i}`] = ['runningHours', 'fuelConsumption'];
      }
      this.grupFuelYatim.forEach((nama) => {
        kolom[`fuel:${nama}`] = [...fuel];
      });
      return kolom;
    },
    currAsset() {
      const currMassId = this.$store.getters['filter/currentMassId'];
      const assets = this.$store.getters['asset/assets'];
      if (!assets) return null;

      return assets.find((asset) => asset.massId === currMassId);
    },
    currAssetSummary() {
      if (!this.currAsset?.summary) return null;

      return {
        series: buildFmsSeries({
          summary: this.currAsset.summary,
          summarySource: this.currAsset.summarySource,
          dateRange: this.dateRange,
          interval: 'hour',
          intervalSecondsOverride: 60 * 60,
          roundingStrategy: 'legacy-hour',
          normalizeHourlyTimestamps: true,
          dataSort: this.dataSort,
        }),
      };
    },
  },
  watch: {
    // Kapal ganti: tab yang sensornya ilang jangan ditinggalin aktif.
    chartTabs(baru) {
      if (baru.some((t) => t.index === this.chartActive)) return;
      this.chartActive = baru.length ? baru[0].index : 0;
    },
    // Pilihan kolom kapal sebelumnya jangan bocor ke kapal berikutnya.
    availableColumns: {
      handler(baru) {
        const disaring = {};
        Object.keys(baru).forEach((key) => {
          const lama = this.visibleColumns[key];
          disaring[key] = Array.isArray(lama)
            ? lama.filter((c) => baru[key].includes(c))
            : [...baru[key]];
        });
        this.visibleColumns = disaring;
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._onResize);
    publish(HOVER, null);
  },
  methods: {
    toDuration,
    formatDateTime,
    formatDisplay: (v) => formatDateTime(v, DISPLAY_DATETIME),
    moment,
    convertDecimalToDMS(decimal, isLatitude) {
      const degrees = Math.floor(Math.abs(decimal));
      const minutesDecimal = (Math.abs(decimal) - degrees) * 60;
      const minutes = Math.floor(minutesDecimal);
      const seconds = Math.round((minutesDecimal - minutes) * 60);

      // eslint-disable-next-line no-nested-ternary
      const direction = decimal >= 0
        ? (isLatitude ? 'N' : 'E')
        : (isLatitude ? 'S' : 'W');

      return `${degrees}° ${minutes}' ${seconds}'' ${direction}`;
    },
    showShowHideModal() {
      this.$bvModal.show('show-hide-column-modal');
    },
    hideShowHideModal() {
      this.$bvModal.hide('show-hide-column-modal');
    },
    areAllVisible(key) {
      return this.availableColumns[key].every((column) => this.visibleColumns[key].includes(column));
    },
    toggleAllColumns(key) {
      if (this.areAllVisible(key)) {
        this.visibleColumns[key] = [];
      } else {
        this.visibleColumns[key] = [...this.availableColumns[key]];
      }
    },
    labelGrup(key) {
      if (key.startsWith('fuel:')) return `${key.slice(5)} Fuel`;
      const cocokAe = /^ae(\d+)$/.exec(key);
      if (cocokAe) return `AE ${cocokAe[1]}`;
      return key.charAt(0).toUpperCase() + key.slice(1);
    },
    // volumeInventory nyumbang dua kolom, sisanya satu.
    visibleCount(key) {
      return (this.availableColumns[key] || [])
        .filter((c) => (this.visibleColumns[key] || []).includes(c))
        .reduce((n, c) => n + (c === 'volumeInventory' ? 2 : 1), 0);
    },
    sorotBaris(data) {
      publish(HOVER, Number(data.timestamp) * 1000);
    },
    lepasBaris() {
      publish(HOVER, null);
    },
    // ponytail: header & baris dibaca dari tabel yang kegambar, jadi ekspor gak
    // mungkin beda sama yang dilihat user. Kalau tabelnya suatu saat divirtualisasi,
    // ini harus pindah ke sumber datanya.
    headerEkspor(thead) {
      const r1 = [...thead.rows[0].cells];
      const r2 = thead.rows[1] ? [...thead.rows[1].cells] : [];
      const keluar = [];
      let i2 = 0;
      r1.forEach((th) => {
        if (th.getAttribute('rowspan') === '2') {
          keluar.push(th.innerText.trim());
          return;
        }
        const rentang = Number(th.getAttribute('colspan') || 1);
        for (let k = 0; k < rentang; k += 1) {
          const sub = r2[i2] ? r2[i2].innerText.trim() : '';
          keluar.push(`${th.innerText.trim()} - ${sub}`);
          i2 += 1;
        }
      });
      return keluar;
    },
    async onDownloadExcel() {
      const tabel = this.$el.querySelector('#datalog-content table');
      if (!tabel) return;

      const header = this.headerEkspor(tabel.tHead);
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Datalog');
      worksheet.columns = header.map((h) => ({ header: h, key: h, width: 24 }));

      [...tabel.tBodies[0].rows].forEach((tr) => {
        worksheet.addRow([...tr.cells].map((td) => numericCell(td.innerText.trim())));
      });

      const r = this.dateRange;
      const nama = [
        this.currAsset?.massName || 'asset',
        formatDateTime(r.start, 'DD-MM-YYYY HH:mm', null, false),
        formatDateTime(r.end, 'DD-MM-YYYY HH:mm', null, false),
      ].join(' - ');
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `${nama}.xlsx`);
    },
  },
};
</script>

<style scoped>
#map-viewer-menu {
  position: absolute;
  right: 0;
  bottom: 0px;
  background-color: #FFFFFF;
  z-index: 1050;
}

#sheet-controls {
  display: flex;
  align-items: center;
  border-right: 2px solid #E8ECF3;
  padding: 4px 8px;
  white-space: nowrap;
}

.sheet-btn {
  border: 0;
  border-radius: 6px;
  background: #ff69b4;
  color: #ffffff;
  font-weight: 700;
  font-size: 12px;
  padding: 4px 12px;
  margin-right: 6px;
}

#menu-bar {
  height: 55px;
  background-color: #F2F4F4;
  display: flex;
}

#close-menu {
  cursor: pointer;
  color: #E5398C;
  border-right: 2px solid #E8ECF3;
  width: 55px;
  text-align: center;
  font-size: 23px;
  padding: 4px;
}

#menu-content {
  display: flex;
  flex-direction: row;
  height: calc(100% - 55px);
}

#content-selector {
  display: flex;
  flex-direction: column;
  min-width: 55px;
  max-width: 55px;
}

#chart-header {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #E8ECF3;
  padding: 0;
}

.chart-selector {
  padding: 13.5px 15px;
  text-align: center;
  align-items: center;
  cursor: pointer;
  color: #2c3e50;
}

.active-chart-selector {
  background-color: #E5398C;
  color: white !important;
}

#chart-content {
  overflow-x: auto;
  width: 100%;
  height: 100%;
  position: relative;
}

.selector {
  cursor: pointer;
  border-bottom: 2px solid #E8ECF3;
  padding: 5px 10px;
  text-align: center;
}

.active-selector {
  background-color: #E5398C;
}

#datalog-content {
  overflow: auto;
  height: 100%;
  width: 100%;
  position: relative;
}

#datalog-content table {
  table-layout: auto;
  width: auto;
  border-collapse: separate;
  border-spacing: 0;
}

#datalog-content table thead {
  position: sticky;
  top: 0;
  z-index: 3;
}

#datalog-content table thead tr th {
  border: 1px solid rgb(234, 234, 234);
  padding: 4px 8px;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
  color: #495057;
  background-color: #DEE2E6;
}

#datalog-content table tbody tr td {
  border: 1px solid rgb(234, 234, 234);
  padding: 8px 6px;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
  color: #495057;
  background-color: #fefefe;
}

#datalog-content table tbody tr:nth-child(even) {
  background-color: #E9ECEF;
}

#datalog-content table th.sticky-column,
#datalog-content table td.sticky-column {
  position: sticky;
  left: 0;
  z-index: 2;
  background-color: #E9ECEF;
}

#datalog-content table td.sticky-column {
  background-color: #fefefe;
}

#datalog-content table tr:nth-child(even) td.sticky-column {
  background-color: #fefefe;
}
</style>
